/**
 * Trading SettingsTab constants — extracted in iter-83.
 *
 * STRATEGY_CATALOG: 6 trading strategies presented as toggleable cards.
 * TRADABLE_PAIRS:   11 pairs supported by the bot (Forex + Gold + CNH/HKD).
 *
 * Note: `TRADING_MODES` was removed — Trading Mode is now auto-derived from
 * the active MetaApi profile (Demo/Live), not a UI choice.
 */

export const STRATEGY_CATALOG = [
  {
    id: 'smc',
    nameAr: 'سيولة المؤسسات (SMC)',
    nameEn: 'Institutional Liquidity (SMC)',
    descAr: 'اصطياد السيولة + مناطق المؤسسات + هيكل السوق',
    descEn: 'Liquidity sweeps + order blocks + market structure'
  },
  {
    id: 'classic',
    nameAr: 'المؤشرات الفنية',
    nameEn: 'Technical Indicators',
    descAr: 'EMA + RSI + MACD + Bollinger الكلاسيكية',
    descEn: 'Classic EMA + RSI + MACD + Bollinger'
  },
  {
    id: 'breakout',
    nameAr: 'اختراق المستويات',
    nameEn: 'Breakout',
    descAr: 'اختراق نطاقات التداول مع تأكيد الزخم (ممتاز للذهب)',
    descEn: 'Range breakouts with momentum confirmation (great for gold)'
  },
  {
    id: 'trend_following',
    nameAr: 'متابعة الاتجاه',
    nameEn: 'Trend Following',
    descAr: 'EMA + MACD لركوب الموجات القوية',
    descEn: 'EMA + MACD to ride strong waves'
  },
  {
    id: 'mean_reversion',
    nameAr: 'الارتداد للمتوسط',
    nameEn: 'Mean Reversion',
    descAr: 'شراء عند الانخفاض الزائد / بيع عند الارتفاع الزائد',
    descEn: 'Buy oversold / sell overbought pullbacks'
  },
  {
    id: 'scalping',
    nameAr: 'سكالبينج',
    nameEn: 'Scalping',
    descAr: 'صفقات سريعة على M5 من ارتدادات RSI',
    descEn: 'Quick M5 trades from RSI reversals'
  },
];

// 11 tradable pairs as defined by the product owner (Forex majors + crosses + Gold + CNH/HKD)
export const TRADABLE_PAIRS = [
  { code: 'EURUSD', display: 'EUR/USD', group: 'FX' },
  { code: 'USDJPY', display: 'USD/JPY', group: 'FX' },
  { code: 'GBPUSD', display: 'GBP/USD', group: 'FX' },
  { code: 'EURGBP', display: 'EUR/GBP', group: 'FX' },
  { code: 'USDCHF', display: 'USD/CHF', group: 'FX' },
  { code: 'GBPJPY', display: 'GBP/JPY', group: 'FX' },
  { code: 'AUDUSD', display: 'AUD/USD', group: 'FX' },
  { code: 'USDCAD', display: 'USD/CAD', group: 'FX' },
  { code: 'XAUUSD', display: 'XAU/USD', group: 'Metal' },
  { code: 'USDCNH', display: 'USD/CNH', group: 'FX' },
  { code: 'USDHKD', display: 'USD/HKD', group: 'FX' },
];
